module.exports = __webpack_public_path__ + "img/home3.5f046857.jpg";